import ComponentRegistry from "Fratello/Common/ComponentRegistry";

// Product Browser
import ProductBrowserProductsWidget from "Fratello/ProductBrowser/Widgets/ProductsWidget";
import ProductBrowserFacetsWidget from "../ProductBrowser/Widgets/FacetsWidget";
import ProductBrowserHistoryWidget from "Fratello/ProductBrowser/Widgets/HistoryWidget";

import ProductBrowserAtomsFooter from "../ProductBrowser/Atoms/Footer";
import ProductBrowserAtomsHeader from "../ProductBrowser/Atoms/Header";

import ProductBrowserAtomsFacetMultiCheckbox from "../ProductBrowser/Atoms/Facet/MultiCheckbox";

import ProductBrowserViewsProductsView from "../ProductBrowser/Views/ProductsView";
import ProductBrowserViewsFacetsView from "../ProductBrowser/Views/FacetsView";
import ProductBrowserViewsFacetView from "../ProductBrowser/Views/FacetView";
import ProductBrowserViewsThumbView from "../ProductBrowser/Views/ThumbView";
import ProductBrowserViewsListView from "Fratello/ProductBrowser/Views/ListView";
import ProductBrowserViewsPresentationView from "Fratello/ProductBrowser/Views/PresentationView";
import {createProductBrowserStore as ProductBrowserStore} from "Fratello/ProductBrowser/Stores/ProductBrowserStore";
import ProductBrowserFacetStore from "Fratello/ProductBrowser/Stores/FacetStore";

// Product Browser Store
ComponentRegistry.registerStore({ProductBrowserStore});
ComponentRegistry.registerStore({ProductBrowserFacetStore});

ComponentRegistry.register({ProductBrowserProductsWidget});
ComponentRegistry.register({ProductBrowserFacetsWidget});
ComponentRegistry.register({ProductBrowserHistoryWidget});

ComponentRegistry.register({ProductBrowserAtomsFooter});
ComponentRegistry.register({ProductBrowserAtomsHeader});
ComponentRegistry.register({ProductBrowserAtomsFacetMultiCheckbox});

ComponentRegistry.register({ProductBrowserViewsProductsView});
ComponentRegistry.register({ProductBrowserViewsFacetsView});
ComponentRegistry.register({ProductBrowserViewsFacetView});
ComponentRegistry.register({ProductBrowserViewsPresentationView});

ComponentRegistry.register({ProductBrowserViewsThumbView});
ComponentRegistry.register({ProductBrowserViewsListView});



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Components/ProductBrowser.jsx